import { render, staticRenderFns } from "./ChatWithUs.vue?vue&type=template&id=2583790b"
import script from "./ChatWithUs.vue?vue&type=script&lang=ts"
export * from "./ChatWithUs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports